// extracted by mini-css-extract-plugin
export default {"Container":"StatusComponent_Container__bcLrK"};